/**
 * Centralized Logging Service
 * Provides structured logging with different levels and environment-based configuration
 */

const LOG_LEVELS = {
  ERROR: 0,
  WARN: 1,
  INFO: 2,
  DEBUG: 3
}

class Logger {
  constructor () {
    this.level = this.getLogLevel()
    this.isProduction = process.env.NODE_ENV === 'production'
  }

  getLogLevel () {
    const envLevel = process.env.VUE_APP_LOG_LEVEL || 'INFO'
    return LOG_LEVELS[envLevel.toUpperCase()] ?? LOG_LEVELS.INFO
  }

  shouldLog (level) {
    return LOG_LEVELS[level] <= this.level
  }

  error (message, context = {}) {
    if (!this.isProduction && this.shouldLog('ERROR')) {
      console.error(`[ERROR] ${message}`, context)
    }
  }

  warn (message, context = {}) {
    if (!this.isProduction && this.shouldLog('WARN')) {
      console.warn(`[WARN] ${message}`, context)
    }
  }

  info (message, context = {}) {
    if (!this.isProduction && this.shouldLog('INFO')) {
      console.info(`[INFO] ${message}`, context)
    }
  }

  debug (message, context = {}) {
    if (!this.isProduction && this.shouldLog('DEBUG')) {
      console.debug(`[DEBUG] ${message}`, context)
    }
  }
}

// Create singleton instance
const logger = new Logger()

export default logger
